import jsPDF from "jspdf";

export const createQRPDFFromSignedUrl = async (signedUrl: string) => {
	// Load image
	const img = new Image();
	img.crossOrigin = "anonymous"; // REQUIRED for GCS

	await new Promise<void>((resolve, reject) => {
		img.onload = () => resolve();
		img.onerror = reject;
		img.src = signedUrl;
	});

	// Create PDF (A4)
	const pdf = new jsPDF({
		orientation: "portrait",
		unit: "mm",
		format: "a4"
	});

	const pageWidth = pdf.internal.pageSize.getWidth();
	const pageHeight = pdf.internal.pageSize.getHeight();

	// Ideal QR size for print
	const qrSizeMm = 80;
	const x = (pageWidth - qrSizeMm) / 2;
	const y = (pageHeight - qrSizeMm) / 2;

	pdf.addImage(img, "PNG", x, y, qrSizeMm, qrSizeMm);

	return pdf;
};
